<template>
  <div>
    <v-alert
      outlined
      dismissible
      type="info"
      class="mt-3"
    >
      <a style="color: inherit; text-decoration: underline;" href="https://corporate.tracefy.net/" target="_blank">{{ t({s: 'intro.link', component: 'Information'}) }}</a>
    </v-alert>
  </div>
</template>

<script>

export default {
  name: 'InfoAlert'
}
</script>

<style scoped>@import 'styles.css';</style>
